export const ADMIN_CREDENTIALS = {
  email: "admin@tradix.com",
  password: "ChangeMe!@#",
  name: "Admin",
};

const AUTH_STORAGE_KEY = "tradix-admin-session";

export function isAuthenticated() {
  if (typeof window === "undefined") {
    return false;
  }
  return localStorage.getItem(AUTH_STORAGE_KEY) === "true";
}

export function login(email, password) {
  const normalizedEmail = (email || "").trim().toLowerCase();
  const isValid =
    normalizedEmail === ADMIN_CREDENTIALS.email &&
    password === ADMIN_CREDENTIALS.password;

  if (isValid && typeof window !== "undefined") {
    localStorage.setItem(AUTH_STORAGE_KEY, "true");
  }

  return isValid;
}

export function logout() {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(AUTH_STORAGE_KEY);
}
